var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfectum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "144.000000pt",
    height: "103.000000pt",
    viewBox: "0 0 144.000000 103.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,103.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M924 927 c-2 -7 -3 -114 -2 -237 3 -198 5 -225 19 -225 23 0 155 122 169 156 7 16 10 35 7 42 -13 34 10 33 47 0 l38 -35 -141 -143 -142 -142 3 -159 c3 -151 4 -159 23 -159 19 0 20 8 23 150 l2 151 145 144 c80 80 145 149 145 155 0 6 -31 42 -70 80 -58 58 -70 75 -70 102 0 18 4 33 8 33 10 0 212 -204 212 -214 0 -3 -61 -68 -135 -144 l-134 -137 -1 -87 c0 -80 2 -88 19 -88 25 0 31 19 31 96 l0 64 146 144 c123 123 144 148 135 163 -19 34 -301 305 -313 301 -7 -3 -14 -25 -16 -51 -2 -26 -7 -47 -12 -47 -5 0 -30 23 -56 50 -47 50 -70 61 -80 37z m105 -129 c40 -41 41 -45 39 -103 -2 -55 -5 -63 -42 -102 -23 -24 -44 -43 -48 -43 -5 0 -8 65 -8 145 0 82 4 145 9 145 5 0 28 -19 50 -42z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M55 880 c-12 -20 -8 -221 5 -234 15 -14 40 18 40 51 0 20 5 23 35 23 90 0 135 74 81 136 -20 24 -32 28 -88 32 -45 3 -68 0 -73 -8z m125 -59 c18 -36 -7 -60 -62 -61 -14 0 -18 9 -18 40 0 39 1 40 35 40 24 0 37 -6 45 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M313 883 c-9 -3 -13 -37 -13 -118 0 -94 3 -114 16 -119 24 -9 34 2 34 40 0 31 2 34 30 34 17 0 30 -3 30 -7 0 -12 60 -73 71 -73 20 0 20 31 -1 60 -20 28 -21 32 -6 43 9 7 20 26 25 43 11 39 -4 73 -39 91 -24 12 -122 17 -147 6z m132 -78 c0 -29 -2 -30 -47 -33 l-48 -3 0 36 0 36 48 -3 c45 -3 47 -4 47 -33z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M594 857 c-29 -26 -37 -42 -40 -77 -6 -54 9 -86 55 -117 70 -47 163 -16 190 63 18 52 9 88 -34 131 -29 29 -39 33 -84 33 -44 0 -56 -5 -87 -33z m140 -36 c23 -24 24 -86 0 -112 -27 -30 -87 -26 -113 7 -63 80 40 175 113 105z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M643 596 c-41 -18 -73 -70 -73 -116 0 -39 29 -93 57 -108 40 -21 114 -18 144 7 20 16 21 21 10 35 -12 14 -16 14 -42 1 -40 -21 -66 -19 -94 10 -65 64 17 172 94 123 20 -12 51 -5 51 11 0 16 -45 41 -81 47 -19 2 -49 -2 -66 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M50 479 c0 -119 0 -120 23 -117 19 3 22 10 25 49 l3 45 48 -3 c34 -3 51 0 60 11 21 25 3 36 -55 36 -53 0 -54 0 -54 30 l0 30 65 0 c58 0 65 2 65 20 0 19 -7 20 -90 20 l-90 0 0 -121z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M314 587 c-2 -7 -3 -60 -2 -118 l3 -104 90 0 c73 0 90 3 90 15 0 12 -15 16 -67 18 -68 3 -68 3 -68 32 0 28 1 29 58 32 43 2 57 7 57 18 0 11 -14 16 -57 18 -57 3 -58 4 -58 32 l0 30 65 0 c58 0 65 2 65 20 0 18 -7 20 -85 20 -62 0 -87 -4 -91 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M51 311 c-25 -16 -4 -41 34 -41 l35 0 0 -95 c0 -78 3 -97 16 -102 26 -10 34 16 34 109 l0 87 33 3 c24 2 32 8 32 23 0 18 -8 20 -85 23 -47 1 -91 -2 -99 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M307 313 c-4 -3 -7 -46 -7 -95 0 -86 1 -91 29 -119 34 -33 83 -39 130 -14 40 20 52 59 49 151 -3 71 -5 79 -23 79 -18 0 -20 -8 -25 -85 -3 -47 -9 -91 -13 -97 -10 -16 -69 -17 -85 -1 -7 7 -12 42 -12 88 0 81 -18 119 -43 93z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M567 313 c-12 -11 -8 -231 3 -238 22 -14 39 17 42 77 l3 61 25 -38 c14 -21 30 -40 36 -42 7 -2 25 17 40 42 l29 45 5 -72 c4 -65 7 -73 25 -73 19 0 20 8 23 118 2 98 0 118 -13 123 -21 8 -40 -10 -73 -67 -15 -27 -29 -49 -32 -49 -3 0 -22 27 -42 60 -34 55 -54 70 -71 53z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfectum);
export default __webpack_public_path__ + "static/media/profectum.60734f6d.svg";
export { ForwardRef as ReactComponent };